<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 OS-m — Outros departamentos: Listagem e exibição
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Esta parte explica como
        strong  listar
        |  e
        strong  abrir
        |  Ordens de Serviço (OS-m) de
        strong  outros departamentos
        | , pelo menu
        strong  OS-m → Outros Departamentos
        | . A criação de uma OS informativa fica no manual de Adição.

      .toast.toast-primary
        | A listagem exige a permissão
        strong  Compartilhado → Ordem serviços → Listar
        | .

      h5.h5 1. Abrir Outros Departamentos
      ol
        li No menu lateral, clique em
          strong  OS-m
          | .
        li Clique em
          strong  Outros Departamentos
          | .
      p Você chega à listagem de OS-m compartilhadas com o departamento atual. A lista carrega ao abrir a tela.

      h5.h5 2. Filtros e pesquisa
      figure.manual-figure
        img(:src="imgLista" alt="Listagem Outros Departamentos com filtros e tabela")
      p Acima da tabela ficam os filtros:
      ul
        li
          strong Número
          |  e
          strong  Ano
          |  da OS
        li
          strong Cadastro
          |  — vínculo opcional a um cadastro
        li
          strong Data início
          |  e
          strong  Data fim
          |  (data de inserção)
      ol
        li Preencha os critérios desejados.
        li Clique na
          strong  lupa
          |  (
          em Pesquisar
          | ) para aplicar a busca.
        li O botão
          code  +
          |  abre o fluxo de
          strong  Nova OS-m
          |  (outro manual).

      h5.h5 3. Tabela
      p Cada linha mostra:
      ul
        li
          strong Número/ano
          |  da OS
        li
          strong Assunto
          | , com secretaria e departamento de destino
        li
          strong Cadastro
          |  (quando houver)
        li
          strong Data de inserção
        li
          strong Situação
          |  (ex.: Aguardando Distribuir)
        li Ação
          strong  Exibir
          |  (ícone de olho)
      p Se houver várias páginas, use a paginação no rodapé.

      h5.h5 4. Abrir a OS
      ol
        li Na listagem, localize a linha desejada.
        li Clique em
          strong  Exibir
          |  (ícone de olho).
        li O sistema abre a tela de exibição da OS compartilhada.

      .toast.toast-primary
        | A exibição exige a permissão
        strong  Compartilhado → Ordem serviços → Exibir
        | .

      h5.h5 5. Tela de exibição
      figure.manual-figure
        img(:src="imgShow" alt="Exibição de uma OS-m de outro departamento")
      p No cabeçalho você vê o número/ano da OS, o assunto e o departamento de destino (secretaria, diretoria e departamento).
      p O painel reúne:
      ul
        li
          strong Sobre a OS
          |  — protocolo, situação, cadastro (quando houver)
        li
          strong Itens
          |  — campos preenchidos, se existirem
        li
          strong Responsáveis
          |  — emissor e demais responsáveis
        li
          strong Datas
          |  — inserção e demais marcas de tempo
        li
          strong Observações
          |  — texto livre da OS
      p No rodapé, use
        strong  Imprimir
        |  para abrir a versão para impressão em nova aba.

      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgLista: require("@/assets/manuais/09-osm-outros-dept-lista.png"),
      imgShow: require("@/assets/manuais/09a-osm-outros-dept-show.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
